import Constants from '../constants/Constants';
import ApiUtil from '../util/ApiUtil';

const baseUrl = '/api/v1/transcription';

const startAutomatedTranscription = async (mediaHash: string) => await ApiUtil.executePostAsync(`${baseUrl}/${mediaHash}`, [Constants.statusCodes.accepted]);

const startThirdPartyTranscription = async (mediaHash: string) => await ApiUtil.executePostAsync(`${baseUrl}/${mediaHash}/thirdparty`, [Constants.statusCodes.accepted]);

const cancelAutomatedTranscription = async (mediaHash: string) => {
   await ApiUtil.executeDeleteAsync(`${baseUrl}/${mediaHash}`, [Constants.statusCodes.noContent]);
};

const approveThirdPartyTranscription = async (mediaHash: string) => {
   await ApiUtil.executePutAsync(`${baseUrl}/${mediaHash}/thirdparty`, [Constants.statusCodes.accepted]);
};

const cancelThirdPartyTranscription = async (mediaHash: string) => {
   await ApiUtil.executeDeleteAsync(`${baseUrl}/${mediaHash}/thirdparty`, [Constants.statusCodes.noContent]);
};

export default {
   startAutomatedTranscription,
   startThirdPartyTranscription,
   cancelAutomatedTranscription,
   approveThirdPartyTranscription,
   cancelThirdPartyTranscription
};
